<template>
  <div>
    <b-table :fields="fields" :items="list.data">
      <template #head(checkbox)="data">
        <b-form-checkbox />
      </template>
      <template #cell(checkbox)="data">
        <b-form-checkbox />
      </template>

      <template #cell(status)="data">
        <div dir="ltr" class="d-flex justify-content-center">
          <b-form-checkbox switch size="lg" />
        </div>
      </template>

      <template #cell(actions)="data">
        <b-button v-b-tooltip.hover title="ویرایش" size="sm" class="mr-1">
          <b-icon-pencil />
        </b-button>
        <b-button v-b-tooltip.hover title="حذف" size="sm" class="mr-1">
          <b-icon-trash />
        </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col sm="5" md="3" class="my-1">
        <b-form-group
          label="تعداد در صفحه"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="5"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="pageSize"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="4" class="offset-lg-5">
        <b-pagination
          v-model="pageIndex"
          :total-rows="list.totalCount"
          :per-page="pageSize"
          align="fill"
          size="md"
          first-number
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "ListTable",
  data() {
    return {
      pageSize: 15,
      pageOptions: [15, 30, 60, 100],
      pageIndex: 1,
      isSelectedAll: false,
      title: ""
    };
  },

  computed: {
    ...mapGetters({
      list: "brand/list",
      fields: "brand/fields"
    })
  },
  watch: {
    pageIndex(value) {
      this.init();
    },
    pageSize(value) {
      this.init();
    },
    title(value) {
      this.init();
    }
  },

  methods: {
    ...mapActions({
      fetchList: "brand/fetchList"
    }),

    init() {
      this.fetchList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        title: this.title
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped></style>
